/**
 * Share helpers for invite links.
 */

export function buildTwitterShareUrl(text, url) {
  const params = new URLSearchParams({
    text: `${text} ${url}`,
  });
  return `https://twitter.com/intent/tweet?${params.toString()}`;
}

export function buildFacebookShareUrl(url) {
  const params = new URLSearchParams({ u: url });
  return `https://www.facebook.com/sharer/sharer.php?${params.toString()}`;
}

/** Opens the default SMS app with a pre-filled invite message. */
export function buildSmsShareUrl(message) {
  const body = encodeURIComponent(message);
  return `sms:?&body=${body}`;
}

export function buildMailtoInviteUrl(to, subject, body) {
  const params = new URLSearchParams();
  if (subject) params.set('subject', subject);
  if (body) params.set('body', body);
  if (to) params.set('to', to);
  return `mailto:?${params.toString()}`;
}

export async function copyToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return true;
  }
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.style.position = 'fixed';
  ta.style.left = '-9999px';
  document.body.appendChild(ta);
  ta.select();
  try {
    document.execCommand('copy');
    return true;
  } catch {
    return false;
  } finally {
    document.body.removeChild(ta);
  }
}

export function canNativeShare() {
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}

export async function nativeShare({ title, text, url }) {
  await navigator.share({ title, text, url });
}
